module.exports = __webpack_public_path__ + "img/fjhover.70082e6e.svg";